export default "__VITE_ASSET__MUEv_2FK__"